<template>
  <div>
    <div class="px-4 pb-3">
      <v-btn style="float: right" icon @click="$emit('close')">
        <v-icon>close</v-icon>
      </v-btn>

      <div style="font-size: 20px; font-weight: 600" class="pt-3 mb-3">
        {{ edittype == 'create' ? 'เพิ่ม' : 'แก้ไข' }}ข้อมูลร้าน
      </div>
      <div class="form-control">
        <v-layout class="pa-0 ma-0" wrap row>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('departmentStore') }"
          >
            <label>{{ $t('รหัสร้านค้า') }}</label>
            <input
              v-model="input.store_id"
              v-validate="'required'"
              :data-vv-as="$t('รหัสร้านค้า')"
              class="form-control"
              type="text"
              name="storeId"
            />
            <span v-if="errors.has('storeId')" class="text-error">{{
              errors.first('storeId')
            }}</span>
          </v-flex>
          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('storeName') }"
          >
            <label>{{ $t('ชื่อร้านค้า') }}</label>
            <input
              v-model="input.store_name"
              v-validate="'required'"
              :data-vv-as="$t('ชื่อร้านค้า')"
              class="form-control"
              type="text"
              name="storeName"
            />
            <span v-if="errors.has('storeName')" class="text-error">{{
              errors.first('storeName')
            }}</span>
          </v-flex>

          <v-flex
            xs12
            sm6
            class="form-control pa-1"
            :class="{ 'has-error': errors.has('storeArea') }"
          >
            <label>{{ $t('พื้นที่') }}</label>
            <input
              v-model="input.store_area"
              v-validate="'required'"
              :data-vv-as="$t('พื้นที่')"
              class="form-control"
              type="text"
              name="storeArea"
            />
            <span v-if="errors.has('storeArea')" class="text-error">{{
              errors.first('storeArea')
            }}</span>
          </v-flex>
        </v-layout>
        <div class="text-xs-center">
          <v-btn outline color="grey" @click="$emit('close')">cancel</v-btn>
          <v-btn :loading="saveloading" depressed color="primary" @click="savedata">save</v-btn>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/api'
import { mapGetters } from 'vuex'
import { PAGE } from '@/constants/page.js'
import toaMegapaintApi from '@/api/toa-mega-paint.js'

export default {
  props: ['edittype', 'editdata'],
  data() {
    return {
      saveloading: false,
      input: {
        id: '',
        store_id: '',
        store_name: '',
        store_area: ''
      }
    }
  },
  computed: {
    ...mapGetters(['selectedBot'])
  },
  mounted() {
    if (this.edittype == 'edit') {
      this.input = {
        id: this.editdata.id,
        store_id: this.editdata.store_id,
        store_name: this.editdata.store_name,
        store_area: this.editdata.store_area
      }
    }
  },
  methods: {
    async savedata() {
      if (await this.$validator.validateAll()) {
        if (this.edittype == 'create') {
          this.createdata()
        } else {
          this.editbranch()
        }
      }
    },
    async editbranch() {
      var data = {
        page_id: this.selectedBot.pageid,
        pageid: this.selectedBot.pageid,
        ...this.input,
        campaign_id: this.$store.state.selectToaCampaign
          ? this.$store.state.selectToaCampaign.id
          : null
      }
      this.saveloading = true

      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          await toaMegapaintApi.putStore(data)
          this.$emit('onsave')
        } catch (error) {
          console.error(error)
        } finally {
          this.saveloading = false
        }
      } else {
        api.updateStoreToaecoupon(data, (err, response) => {
          this.saveloading = false
          if (response.responsecode == 200) {
            this.$emit('onsave')
          }
        })
      }
    },
    async createdata() {
      var data = {
        page_id: this.selectedBot.pageid,
        pageid: this.selectedBot.pageid,
        ...this.input,
        campaign_id: this.$store.state.selectToaCampaign
          ? this.$store.state.selectToaCampaign.id
          : null
      }
      this.saveloading = true

      if (PAGE.TOA_MEGA_PAINT.includes(this.selectedBot.pageid)) {
        try {
          await toaMegapaintApi.postStore(data)
          this.$emit('onsave')
        } catch (error) {
          console.error(error)
        } finally {
          this.saveloading = false
        }
      } else {
        api.insertStoreToaecoupon(data, (err, response) => {
          this.saveloading = false
          if (response.responsecode == 200) {
            this.$emit('onsave')
          }
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/view/template/toaecoupon/BranchEdit.vue